/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  /*!*******************************************!*\
  !*** ./_build/scripts/sections/header.js ***!
  \*******************************************/
  const selectors = {
    container: 'header > nav',
    detailsContainer: 'details',
    summaryToggle: 'summary',
    menu: 'details > ul',
  };

  const header = {
    init() {
      const container = document.querySelector(selectors.container);
      const detailsContainers = container.querySelectorAll(selectors.detailsContainer);
      const mql = window.matchMedia(`(min-width: ${theme.breakpoints.lg}px)`);
      const debouncedInteract = debounce(this.onSummaryInteract.bind(this), 150);

      const setupEventListeners = () => {
        // First remove all existing listeners
        detailsContainers.forEach((detailsContainer) => {
          const summaryToggle = detailsContainer.querySelector(selectors.summaryToggle);
          summaryToggle.removeEventListener('mouseover', debouncedInteract);
          summaryToggle.removeEventListener('click', debouncedInteract);
          detailsContainer.removeEventListener('mouseout', debouncedInteract);
        });

        // Add new listeners based on current screen size
        detailsContainers.forEach((detailsContainer) => {
          const summaryToggle = detailsContainer.querySelector(selectors.summaryToggle);
          if (mql.matches) {
            summaryToggle.addEventListener('mouseover', debouncedInteract);
            detailsContainer.addEventListener('mouseout', debouncedInteract);
            detailsContainer.addEventListener('click', (e) => e.stopPropagation());
          } else {
            summaryToggle.addEventListener('click', (e) => {
              e.stopPropagation();
              debouncedInteract(e);
            });
          }
        });
      };

      // Initial setup
      setupEventListeners();

      // Add resize listener
      mql.addEventListener('change', () => setupEventListeners());
    },
    onSummaryInteract(event) {
      // Only check for summary toggle on click and mouseover, not mouseout
      if (event.type !== 'mouseout' && !event.target.closest(selectors.summaryToggle)) {
        return;
      }

      event.preventDefault();
      const container = document.querySelector(selectors.container);
      const detailsContainers = container.querySelectorAll(selectors.detailsContainer);
      const mql = window.matchMedia(`(min-width: ${theme.breakpoints.lg}px)`);
      const currentDetails = event.target.closest('details');

      if (event.type === 'click' && !mql.matches) {
        event.stopPropagation();

        const isOpen = currentDetails.hasAttribute('open');

        // Close all other dropdowns first
        detailsContainers.forEach((container) => {
          if (container !== currentDetails) {
            container.removeAttribute('open');
            container.querySelector(selectors.summaryToggle).setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current dropdown
        if (!isOpen) {
          currentDetails.setAttribute('open', true);
          event.target.setAttribute('aria-expanded', 'true');
        } else {
          currentDetails.removeAttribute('open');
          event.target.setAttribute('aria-expanded', 'false');
        }
      } else if (event.type === 'mouseover' && mql.matches) {
        detailsContainers.forEach((container) => {
          if (container !== currentDetails) {
            container.removeAttribute('open');
            container.querySelector(selectors.summaryToggle).setAttribute('aria-expanded', 'false');
          }
        });
        if (!currentDetails.hasAttribute('open')) {
          this.open(event);
        }
      } else if (event.type === 'mouseout' && mql.matches) {
        const relatedTarget = event.relatedTarget;
        if (!relatedTarget?.closest('details') || relatedTarget?.closest('details') !== currentDetails) {
          this.close(event);
        }
      }
    },
    open(event) {
      event.target.closest('details').setAttribute('open', true);
    },
    close(event) {
      event.target.closest('details').removeAttribute('open');
    },
    onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
    },
  };

  header.init();

  /******/
})();
